var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "document-type-search" },
    [
      _c("b-form-input", {
        staticClass: "search-input",
        attrs: {
          value: _vm.value,
          placeholder: "🔍 Buscar tipo de documento..."
        },
        on: {
          input: function($event) {
            return _vm.$emit("input", $event)
          }
        }
      }),
      _vm.value
        ? _c("div", { staticClass: "search-results-info" }, [
            _vm._v(
              " Mostrando " +
                _vm._s(_vm.filteredCount) +
                " de " +
                _vm._s(_vm.totalTypes) +
                " tipos "
            )
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }